import {Component, OnInit} from '@angular/core';
import {EdocComponent} from '@pes/ui';

@Component({
    selector: 'lbpa-edoc',
    templateUrl: './lbpa-edoc.component.html',
    styleUrls: ['./lbpa-edoc.component.scss']
})
export class LbpaEdocComponent extends EdocComponent implements OnInit {

    constructor() {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

}



// WEBPACK FOOTER //
// ./src/app/component/lbpa-edoc/lbpa-edoc.component.ts